import { Flex } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import useEmblaCarousel from 'embla-carousel-react';
import parse from 'html-react-parser';
import Image from 'next/image';
import type React from 'react';
import styled from 'styled-components';

import { SliderDotButton, SliderDotButtonWrapper } from '@/components/shared/slider/SliderDotButton';
import { useSliderDotButton } from '@/components/shared/slider/useSliderDotButton';
import { type GalleryProps, ItemText, ItemTitle, ItemWrapper } from './Shared';

const CarouselContainer = styled(Flex)`
  display: flex;
  ${MEDIA_QUERIES.tabletAndDesktop`
    display: none;
  `}
`;

export const MobileItemsGallery: React.FC<GalleryProps> = ({ items }) => {
  const [emblaRef, slideApi] = useEmblaCarousel({
    containScroll: false,
  });

  const { selectedIndex, scrollSnaps, onDotButtonClick } = useSliderDotButton(slideApi);

  return (
    <CarouselContainer overflow="hidden" ref={emblaRef} flexDirection="column">
      <Flex gap="20px" mb="12px" mt="40px">
        <Flex width="100vw" maxWidth="380px" px="20px">
          <ItemWrapper flexDirection="column" alignItems="center">
            <Image src={items.left.image} alt={items.left.title} style={{ pointerEvents: 'none' }} />
            <ItemTitle>{parse(items.left.title)}</ItemTitle>
            <ItemText>{parse(items.left.subtitle)}</ItemText>
          </ItemWrapper>
        </Flex>
        <Flex width="100vw" maxWidth="380px" px="20px">
          <ItemWrapper flexDirection="column" alignItems="center">
            <Image src={items.center.image} alt={items.center.title} style={{ pointerEvents: 'none' }} />
            <ItemTitle>{parse(items.center.title)}</ItemTitle>
            <ItemText>{parse(items.center.subtitle)}</ItemText>
          </ItemWrapper>
        </Flex>
        <Flex width="100vw" maxWidth="380px" px="20px">
          <ItemWrapper flexDirection="column" alignItems="center">
            <Image src={items.right.image} alt={items.right.title} style={{ pointerEvents: 'none' }} />
            <ItemTitle>{parse(items.right.title)}</ItemTitle>
            <ItemText>{parse(items.right.subtitle)}</ItemText>
          </ItemWrapper>
        </Flex>
      </Flex>

      <SliderDotButtonWrapper>
        {scrollSnaps.map((_, index) => (
          <SliderDotButton key={index} onClick={() => onDotButtonClick(index)} isActive={index === selectedIndex} />
        ))}
      </SliderDotButtonWrapper>
    </CarouselContainer>
  );
};
